import {
  Activity,
  Building2,
  Car,
  CalendarDays,
  CheckCircle2,
  Clock3,
  CreditCard,
  FileSpreadsheet,
  FileText,
  Gauge,
  MessageSquare,
  PhoneCall,
  ShieldAlert,
  Users,
  WalletCards,
  type LucideIcon,
} from 'lucide-react';

// Display-only mirror of AdminDashboard's mainTabs -> moduleKey mapping
// (src/components/AdminDashboard.tsx), kept here so SuperadminDashboard can
// show "what this module controls" on each tile without importing a huge
// tenant-scoped dashboard component. If a tab's moduleKey there changes,
// update the matching entry here too.
export const MODULE_TABS: Record<string, { label: string; icon: LucideIcon }[]> = {
  payroll: [
    { label: 'Closed Check', icon: CheckCircle2 },
    { label: 'Timesheets', icon: Clock3 },
    { label: 'Payout Report', icon: WalletCards },
  ],
  drivers: [
    { label: 'Drivers', icon: Users },
    { label: 'Comms Book', icon: MessageSquare },
  ],
  fleet: [
    { label: 'Fleet', icon: Car },
    { label: 'Fleet Pulse', icon: Activity },
    { label: 'Fleet Capacity', icon: Gauge },
    { label: 'Insurance', icon: ShieldAlert },
  ],
  roster: [{ label: 'Roster', icon: CalendarDays }],
  reports: [
    { label: 'Reports', icon: FileText },
    { label: 'Export Builder', icon: FileSpreadsheet },
  ],
  crm: [{ label: 'CRM', icon: Building2 }],
  ecards: [{ label: 'eCard', icon: CreditCard }],
  ivr: [{ label: 'IVR Calls', icon: PhoneCall }],
};
